import { useEffect, useRef, useState } from 'react';

const AUTO_SPEED = 0.35;
const PAUSE_AFTER_DRAG = 900;

export default function Carousel() {
  const carouselRef = useRef(null);
  const trackRef = useRef(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const carousel = carouselRef.current;
    const track = trackRef.current;
    if (!carousel || !track) return;

    const circle = carousel.querySelector('.stamp-circle-outer');
    const square = carousel.querySelector('.stamp-square-outer');
    let destroyed = false;
    let offset = 0;
    let setWidth = 0;
    let dragging = false;
    let lastX = 0;
    let pauseUntil = 0;

    function normalize() {
      if (!setWidth) return;
      while (offset < -setWidth) offset += setWidth;
      while (offset > 0) offset -= setWidth;
    }

    function tick() {
      if (destroyed) return;
      if (!dragging && performance.now() > pauseUntil) {
        offset -= AUTO_SPEED;
      }
      normalize();
      track.style.transform = `translateX(${offset}px)`;
      if (setWidth && circle && square) {
        const progress = Math.min(1, Math.max(0, -offset / setWidth));
        circle.style.transform = `translateX(${-progress * 70}px)`;
        square.style.transform = `translateX(${progress * 44}px)`;
      }
      requestAnimationFrame(tick);
    }

    function onDown(event) {
      dragging = true;
      lastX = event.clientX;
      try { carousel.setPointerCapture?.(event.pointerId); } catch (_) {}
    }

    function onMove(event) {
      if (!dragging) return;
      offset += event.clientX - lastX;
      lastX = event.clientX;
      normalize();
      track.style.transform = `translateX(${offset}px)`;
    }

    function onUp() {
      if (!dragging) return;
      dragging = false;
      pauseUntil = performance.now() + PAUSE_AFTER_DRAG;
    }

    carousel.addEventListener('pointerdown', onDown);
    carousel.addEventListener('pointermove', onMove);
    carousel.addEventListener('pointerup', onUp);
    carousel.addEventListener('pointercancel', onUp);

    const imgs = Array.from(track.querySelectorAll('img'));
    const initialWidth = track.scrollWidth;

    Promise.all(
      imgs.map((img) =>
        img.complete
          ? Promise.resolve()
          : new Promise((resolve) => {
              img.addEventListener('load', resolve, { once: true });
              img.addEventListener('error', resolve, { once: true });
            })
      )
    ).then(() => {
      if (destroyed || !track.isConnected) return;
      setWidth = track.scrollWidth;
      if (!setWidth) return;

      const copies = Math.max(2, Math.ceil(window.innerWidth / setWidth) + 2);
      const cells = Array.from(track.children);
      for (let c = 0; c < copies; c++) {
        cells.forEach((cell) => track.appendChild(cell.cloneNode(true)));
      }
      imgs.forEach((img) => (img.draggable = false));

      setReady(true);
      tick();
    });

    requestAnimationFrame(tick);

    return () => {
      destroyed = true;
      carousel.removeEventListener('pointerdown', onDown);
      carousel.removeEventListener('pointermove', onMove);
      carousel.removeEventListener('pointerup', onUp);
      carousel.removeEventListener('pointercancel', onUp);
    };
  }, []);

  return (
    <div className="home-carousel" ref={carouselRef}>
      <div className="carousel-track" ref={trackRef}>
        <div className="carousel-cell">
          <img src="/assets/img/IMG_3175.jpg" alt="" />
        </div>
        <div className="carousel-cell">
          <img src="/assets/img/m-111.jpg" alt="" />
        </div>
        <div className="carousel-cell">
          <img src="/assets/img/m-168.jpg" alt="" />
        </div>
        <div className="carousel-cell">
          <img src="/assets/img/m-169.jpg" alt="" />
        </div>
        <div className="carousel-cell double">
          <div className="modal-image">
            <img src="/assets/img/m-270.jpg" alt="" />
          </div>
          <div className="modal-image">
            <img src="/assets/img/m-289.jpg" alt="" />
          </div>
        </div>
        <div className="carousel-cell">
          <img src="/assets/img/m-295.jpg" alt="" />
        </div>
      </div>

    </div>
  );
}
